<header
  class="flex items-center justify-between -mt-6 -mx-6 px-6 header-height text-white bg-accent-700"
  mat-dialog-title
>
  <!-- Title on the left -->
  <div class="flex-grow text-2xl font-semibold tracking-tight flex items-center gap-3">
    {{ data.fileName | truncate: 100 : transloco.getActiveLang() | titlecase }}
  </div>

  <!-- Close button on the right -->
  <button
    [mat-dialog-close]="true"
    class="close-button"
    mat-icon-button
    [matTooltip]="'Close' | transloco"
  >
    <mat-icon [svgIcon]="'heroicons_solid:x'" class="close-icon"></mat-icon>
  </button>
</header>

<div mat-dialog-content class="content-height">
  <ng-container
    *ngIf="
      data.extension === 'png' || data.extension === 'jpg' || data.extension === 'jpeg';
      else docContent
    "
  >
    <div class="w-full h-full flex justify-center items-center">
      <div class="zoom-container" id="zoom-container">
        <lib-ngx-image-zoom
          [thumbImage]="smallImage"
          [fullImage]="bigImage"
          [zoomMode]="'toggle-click'"
          [magnification]="2"
          maxZoomRatio="10"
          style="height: fit-content"
        ></lib-ngx-image-zoom>
      </div>
    </div>
  </ng-container>

  <ng-template #docContent>
    <ng-container *ngIf="data.extension === 'pdf'; else videoContent">
      <div class="centered-content">
        <embed
          [src]="data.fileSrc | trustUrl"
          type="application/pdf"
          width="1200"
          class="embed-document"
        />
      </div>
    </ng-container>
    <ng-template #videoContent>
      <ng-container *ngIf="data.extension === 'mp4' || data.extension === 'mov'">
        <div class="w-full h-full flex justify-center items-center">
          <video
            controls
            autoplay
            [class]="isVideoLoaded ? 'video-content' : 'video-notLoaded'"
            (loadedmetadata)="onVideoLoaded()"
          >
            <source [src]="data.fileSrc" type="video/mp4" />
          </video>
        </div>
      </ng-container>
      <ng-container *ngIf="data.extension !== 'mp4' && data.extension !== 'mov'">
        <app-error-template
          [type]="'error'"
          [title]="'Preview not available' | transloco"
          [bodyMessage]="'Please download the file' | transloco"
        ></app-error-template>
      </ng-container>
    </ng-template>
  </ng-template>
</div>

<mat-dialog-actions align="end" class="action-height">
  <button
    (click)="downloadFile(data.fileSrc, data.fileName)"
    mat-flat-button
    color="primary"
    class="mat-dense"
    mat-button
  >
    {{ 'Download' | transloco }}
  </button>
  <button class="mat-dense" (click)="onClose()" color="primary" mat-button matDialogClose>
    {{ 'Close' | transloco }}
  </button>
</mat-dialog-actions>
